import React, { useState } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { FormatNumber } from "utils/numberUtils";
import { FormatDateShort } from "utils/dateUtils";
import ToolTipPortal from "components/ToolTipPortal/ToolTipPortal";

import { ISalesUnitFinancials } from "Dashboard/scenes/HighRiseSales/domain/ISalesUnitFinancials";

interface IProps {
  payables: ISalesUnitFinancials | undefined;
}

enum NoteType {
  AccountPayable,
}

interface TooltipState {
  isOpen: boolean;
  top: number;
  left: number;
  value: string;
  entryId: number;
  type: NoteType | undefined;
  index: number;
}

const initialState = {
  isOpen: false,
  top: 0,
  left: 0,
  value: "",
  entryId: 0,
  type: undefined,
  index: -1,
};

const Payables = ({ payables }: IProps) => {
  const [tooltip, setTooltip] = useState<TooltipState>(initialState);

  const close = () => {
    setTooltip(initialState);
  };

  return (
    <div className="payables-box">
      <h3><strong>POTRAŽIVANJA / DUGOVANJA</strong></h3>
      <section>
        <div className="buildings-box-header">
          <div>
            <span className="right-align flexBasis75">dugujemo suma</span>
            <span className="strong-txt center-align txt-underline">
              {payables && FormatNumber(payables.receivableAmountTotal)} rsd
            </span>
          </div>
          <div>
            <span className="right-align flexBasis75">isplatili suma</span>
            <span className="strong-txt center-align txt-underline">
              {payables && FormatNumber(payables.paidAmountTotal)} rsd
            </span>
          </div>
        </div>
        <div className="buildings-box-content">
          <div className="list-wrapp">
            {payables?.payments &&
              payables.payments.map((entry, index) => (
                <article key={index}>
                  <div className="col-2">
                    <span className="strong">{entry.payerPartnerName}</span>
                    <button
                      onClick={(e) => {
                        // setTooltip({
                        //   isOpen: true,
                        //   top: e.clientY,
                        //   left: e.clientX,
                        //   value: entry.note,
                        //   entryId: entry.payableId,
                        //   type: NoteType.AccountPayable,
                        //   index,
                        // });
                      }}
                    >
                      <HelpOutlineIcon className="far" fontSize="small" />
                    </button>
                  </div>
                  <div className="larger-first-cell margin-right-30">
                    <span className="box-span right">
                      {FormatNumber(entry.paidAmountRSD)} rsd
                    </span>
                    {/* FIX BOX SIZES */}
                    <span className="box-span blue">
                      {entry.paidAmountEUR} e
                    </span>
                    <span className="box-span">
                      {FormatDateShort(entry.date)}
                    </span>
                  </div>
                </article>
              ))}
          </div>
        </div>
      </section>
      <ToolTipPortal
        {...tooltip}
        onClose={close}
        text="Napomena"
        offset={{ top: -52, left: 10 }}
      >
        <textarea defaultValue={tooltip.value}></textarea>
      </ToolTipPortal>
    </div>
  );
};

export default Payables;
